export default __webpack_public_path__ + "static/cartoon-pink-09811848466c95147a980233d9eb75e2.png";